<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ButtonPrev',

  props: {
    isLink: {
      type: Boolean,
      default: true,
    },

    href: {
      type: String,
      default: '',
    },

    /**
     * クリックした際に発行する emit の名称
     * @description ルート要素の class（o-action__prev）に合わせた名前付きの click を既定とする
     */
    emitName: {
      type: String,
      default: 'click:prev',
    },

    isFontSmall: {
      type: Boolean,
      default: false,
    },

    isFontBold: {
      type: Boolean,
      default: false,
    },

    isInline: {
      type: Boolean,
      default: true,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    prevent: {
      type: Boolean,
      default: true,
    },

    stop: {
      type: Boolean,
      default: true,
    },
  },

  setup(props, context) {
    const runEvent = (e: Event) => {
      if (props.prevent) e.preventDefault()
      if (props.stop) e.stopPropagation()
      context.emit(props.emitName)
    }

    return {
      // methods
      runEvent,
    }
  }
})
</script>

<template>
  <div
    :class="[
      'o-action__prev',
      { 'is-small': isFontSmall },
      { 'is-bold': isFontBold },
      { 'is-inline': isInline },
    ]">
    <a
      v-if="isLink"
      class="o-action__prev--item"
      :href="href">
      <slot>戻る</slot>
    </a>
    <button
      v-else
      class="o-action__prev--item"
      type="button"
      :disabled="disabled"
      @click="runEvent">
      <slot>戻る</slot>
    </button>
  </div>
</template>

<style lang="sass" scoped>
.o-action__prev
  $root: &
  $margin-size-px: 24
  $font-normal-px: 16
  margin-top: #{math.div($margin-size-px, $font-normal-px)}em

  &:first-child
    margin-top: 0

  & &--item
    width: 100%
    display: block
    line-height: 1
    color: $font-orange
    font-size: $font-normal
    text:
      align: center
      decoration: none
    padding: 0.8em 2em
    background-color: transparent
    border-radius: $border-radius
    +transition($duration: $transition-middle)

    &:not(:disabled)
      +mouseover
        background-color: rgba($bg-x-light-gray, 1)

    &:disabled
      color: $font-xx-light-gray

  &.is-small
    #{$root}--item
      font-size: $font-small

  &.is-bold
    #{$root}--item
      font-weight: bold

  &.is-inline
    text-align: center

    #{$root}--item
      max-width: 8em
      display: inline-block
</style>
